import { select } from '@ps/web-core-store';
import type { TrackedTranslation } from '@ps/web-shared-components';
import React from 'react';
import { useForm } from 'react-final-form';
import { useSelector } from 'react-redux';

import useWizardContext from '@swf/core/hooks/useWizardContext';

import type { PaySystem, SavedCard } from '../../../../../../types/Cashier';
import PaymentMethodSelect from '../../../../../PaymentMethodSelect/PaymentMethodSelect';

const setNativeBonusVisibility = (visibility: boolean) =>
  window?.starsweb?.app.setDepositBonusVisibility?.(visibility);

interface Props {
  label: TrackedTranslation;
  options: (PaySystem | SavedCard)[];
  disable: boolean;
  embeddedPropValue: boolean;
  variant?: 'bonusReady';
  onClick?: (callback: () => void) => void;
}

const PaymentMethodsGroup: React.FC<Props> = ({
  label,
  options,
  disable,
  embeddedPropValue,
  variant,
  ...props
}) => {
  const isMobileEmbedded = useSelector(select.device.isMobileEmbedded);
  const { data } = useWizardContext();
  const { change } = useForm();
  const isBonusReadyVariant = variant === 'bonusReady';

  const embeddedProp = isMobileEmbedded
    ? { setNativeBonusVisibility: () => setNativeBonusVisibility(embeddedPropValue) }
    : {};

  return (
    <PaymentMethodSelect
      fieldName="deposit"
      heading={label}
      options={options}
      variant={variant}
      disable={disable}
      {...embeddedProp}
      {...(isBonusReadyVariant &&
        data?.previousBonusCode && {
          onClick: (callback) => {
            change('deposit.bonusCode', data.previousBonusCode);
            delete data.previousBonusCode;
            callback();
          }
        })}
      {...props}
    />
  );
};

export default PaymentMethodsGroup;
